import { Divider, Typography } from '@material-ui/core';
import Breadcrumb from '../Breadcrumb';
import ManageAccess2 from './../../assets/ManageAccess-2.png';
import ManageAccess5 from './../../assets/ManageAccess-5.png';
import ManageAccess6 from './../../assets/ManageAccess-6.png';
import ManageAccess7 from './../../assets/ManageAccess-7.png';
import ManageAccess8 from './../../assets/ManageAccess-8.png';
import ManageAccess9 from './../../assets/ManageAccess-9.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function ManageAccessControl() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.projects.label'),
          helpTopicId: 'projects',
          topicName: t('help.subtopics.manageMembers'),
          topicNameId: 'manage-member'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.manageMembers.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.manageMembers.step1')}</Typography>
      <img className={classes.media} src={ManageAccess5} alt={`${String(t('help.stepAltPrefix'))}1`} />
      <Typography variant="body1">{t('help.pages.manageMembers.step2')}</Typography>
      <img className={classes.media} src={ManageAccess6} alt={`${String(t('help.stepAltPrefix'))}2`} />
      <Typography variant="body1">{t('help.pages.manageMembers.step3')}</Typography>
      <img className={classes.media} src={ManageAccess7} alt={`${String(t('help.stepAltPrefix'))}3`} />
      <Typography variant="body1">{t('help.pages.manageMembers.step4')}</Typography>
      <img className={classes.media} src={ManageAccess8} alt={`${String(t('help.stepAltPrefix'))}4`} />
      <Typography variant="body1">{t('help.pages.manageMembers.step5')}</Typography>
      <img className={classes.media} src={ManageAccess9} alt={`${String(t('help.stepAltPrefix'))}5`} />
      <Typography variant="body1">{t('help.pages.manageMembers.step6')}</Typography>
      <Divider className={classes.divider} />
      <Typography variant="h6">{t('help.pages.manageMembers.tipTitle')}</Typography>
      <img
        className={classes.media}
        src={ManageAccess2}
        alt={String(t('help.alternativeWayAccess'))}
      />
      <HelpFooter />
    </div>
  );
}
